import React, { useEffect, useState } from 'react';
import Background from '../components/Background';
import Button from '../components/Button';
import { getReadingHistory } from '../services/api';
import { useNavigate } from 'react-router-dom';

const History: React.FC = () => {
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const load = async (p = 1) => {
    setLoading(true);
    const res = await getReadingHistory({ page: p, limit: 10 });
    setItems(res.results);
    setLoading(false);
  };

  useEffect(() => {
    load(1);
  }, []);

  return (
    <div className="min-h-screen relative overflow-hidden" style={{ backgroundColor: '#050508' }}>
      <Background />
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <div className="flex items-center justify-between mb-6 sm:mb-8 animate-fade-in">
          <h1 className="text-3xl sm:text-4xl font-heading text-gradient-gold tracking-luxury font-semibold">Reading History</h1>
          <Button variant="secondary" onClick={() => navigate('/user')}>Back</Button>
        </div>
        {loading ? (
          <div className="text-text-secondary font-elegant tracking-luxury-tight text-sm sm:text-base">Loading…</div>
        ) : (
          <div className="space-y-4 animate-fade-in">
            {items.map((h) => (
              <div 
                key={h.id} 
                className="glass-grain rounded-2xl px-6 py-5 backdrop-blur-xl border shadow-2xl"
                style={{
                  borderColor: 'rgba(255, 184, 79, 0.2)',
                  backgroundColor: 'rgba(20, 20, 32, 0.3)',
                  boxShadow: '0 0 40px rgba(255, 184, 79, 0.15), 0 8px 32px rgba(0,0,0,0.4)'
                }}
              >
                <div className="flex items-center justify-between mb-3">
                  <div className="text-text-primary font-heading text-sm tracking-luxury-tight font-medium uppercase">{h.session_type}</div>
                  <div className="text-text-tertiary font-elegant text-xs tracking-luxury-tight">{new Date(h.created_at).toLocaleString()}</div>
                </div>
                <div className="text-text-secondary font-elegant text-sm sm:text-base tracking-luxury-tight mb-2">"{h.initial_question}"</div>
                {h.preview && (
                  <div className="text-text-tertiary font-elegant text-xs sm:text-sm tracking-luxury-tight mb-3">{h.preview}</div>
                )}
                <div className="mt-4">
                  <Button variant="secondary" onClick={() => navigate(`/reading/view/${h.id}`)}>View</Button>
                </div>
              </div>
            ))}
            {items.length === 0 && (
              <div className="text-text-tertiary font-elegant tracking-luxury-tight text-sm sm:text-base text-center py-8">
                No readings yet.
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default History;


